export default {

  api_suss_code: '0', //接口调用成功code

  invalid_login: '401', //登录失败code

  un_admin: '402', //非管理员

  un_reg: '403', //未注册

  quit_reg: '405', //离职

  //判断环境 (接口地址)
  //dev  -> 本地开发 (npm run dev)
  //test -> 测试环境 (npm run build:test)
  //prod -> 正式环境 (npm run build:prod)
  api_url: () => {

    let HOST = process.env.HOST;

    if ( HOST === 'prod' ) {
        //正式(npm run build:prod)
        return 'https://www.u-8d.com/api/'; //正式
    } else if ( HOST === 'test' ) {
        //测试(npm run build:test)
        return 'http://192.168.4.84:8083/' // 测试环境
    } else {
        //本地开发(npm run dev)
        // return 'http://10.150.5.65:8083/'; //波哥
        return 'http://192.168.4.84:8083/' // 测试环境
    }

  },

  file_url: process.env.HOST == "prod"? 'https://www.u-8d.com/oasite/': 'http://192.168.4.84:8084',

  //管理后台地址
  //dev/test -> 测试环境 (npm run dev / npm run build:test)
  //prod -> 正式环境 (npm run build:prod)
  admin_url: process.env.HOST == "prod" ? 'https://admin.u-8d.com/' : 'http://192.168.4.84:8064/',
  // file_url: 'http://192.168.4.84:8083/',
  // file_url: 'https://appu8d.eapps.dingtalkcloud.com/',

  version: '1.0.0', //版本

  timeout: 0, //接口请求超时时间

  //不需要token的接口
  untoken: [
    'client/sys/applicationLogin',
    'sendMsg/SendMessage',
    'supplier/addTryOut'
  ],

  //需要缓存的接口（返回code等于api_suss_code（0）时才会对结果进行缓存）
  is_cache_api: [

      // 'client/discoverProblem/selectDictType', //取得新建问题类型
      // 'client/txl/department/getTree', //通讯录部门树
      // 'client/sq/getDepartmentMembers', //部门成员
      // 'client/discoverProblem/getProblemsList', //发现问题列表
      // 'client/partner/getCondition', //获取合作伙伴条件查询各个列表
      // '/txl/department/searchMembers', //同事的查询数据
      // 'client/partner/getPartnerTypeList',//取得合作伙伴类型
      // 'client/partner/getPartnerList',//合作伙伴列表

  ],

  //不需要校验登录的路由
  no_c_url: [
      '/login',
      '/reg',
      '/demo',
      '/user_signature_h5',
      '/experienceH5',
      '/agreementH5',
      '/indexh5',
      '/user/user_center',
  ],

  //背景需要白色的页面
  need_page: [
      '/login',
      '/reg'
  ],

  //加密key  不可随意改变，接口调用失败警告！！！
  encrypted_key: 'u8D@2019',

  //是否开启dbug
  dbug: false,

}



// WEBPACK FOOTER //
// ./src/config.js